<ng-container *transloco="let t">
  <div iCard>
    <div iCardContent class="flex-1">
      @if (defaultTactic()) {
        <IBadge color="gray" label="{{ t('sd-targeting.product_page') }}" class="ml-2" />

        <span class="ml-5"> {{ t("sd-targeting.ai-powered_targeting") }}</span>

        <span
          class="icon-delete-append float-right cursor-pointer leading-none"
          [class.disabled]="isReadOnly() || isLastTargeting()"
          [iTooltip]="t('sd-targeting.delete_targeting')"
          (click)="!isReadOnly() && disableAutoAlgoExploration(); $event.stopPropagation()"
        >
          <IIcon name="trash" class="text-xl" />
        </span>
      }
      @if (tactic()) {
        <IBadge
          color="gray"
          [label]="
            tactic()!.tacticType === TacticType.BLACKLIST
              ? t('sd-targeting.blacklist_product_pages')
              : t('sd-targeting.product_page')
          "
          class="ml-2"
        />
        <span class="ml-5">{{ segment()?.name }}</span>

        <span
          class="icon-delete-append float-right leading-none"
          [class.disabled]="isReadOnly() || (tactic()!.tacticType !== TacticType.BLACKLIST && isLastTargeting())"
          [iTooltip]="t('sd-targeting.delete_targeting')"
          (click)="!isReadOnly() && removeTacticFromStrategy(); $event.stopPropagation()"
        >
          <IIcon name="trash" class="cursor-pointer text-xl" />
        </span>
        <IIcon
          name="edit"
          (click)="editSegment()"
          [iTooltip]="t('sd-targeting.update_tactic_segment')"
          class="float-right mr-2 cursor-pointer text-xl"
        />
        <span class="counter float-right"> #products: {{ nbProductTargeting() }} </span>
      }
      @if (audience()) {
        <IBadge
          data-testid="sd-targeting-audience"
          color="gray"
          label="{{ t('sd-targeting.remarketing') }}"
          class="ml-2"
        />

        <span class="ml-5"
          >{{
            t("sd-targeting.last_days", [
              audience()!.expressionType | titlecase,
              supportedAudienceMatchType[audience()!.matchType!],
              audience()!.lookback,
            ])
          }}
        </span>
        <span
          class="icon-delete-append float-right cursor-pointer leading-none"
          [class.disabled]="isReadOnly() || isLastTargeting()"
          [iTooltip]="t('sd-targeting.delete_targeting')"
          (click)="!isReadOnly() && removeAudienceFromStrategy(); $event.stopPropagation()"
        >
          <IIcon name="trash" class="text-xl" />
        </span>
      }
    </div>
  </div>
</ng-container>
